var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9077975 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3572 6.47568C17.7593 2.76884 14.425 -0.00704989 9.99467 1.34492e-05C7.73949 0.0748848 5.51884 1.1923 3.96151 3.42361C2.82731 5.04888 2.38729 6.8571 2.74136 8.80305C2.99847 10.2185 3.6023 11.5203 4.29575 12.7811C5.80459 15.5224 7.69615 18.0122 9.73683 20.4025C10.2679 21.0247 10.8108 21.017 11.3507 20.3912C12.2506 19.3472 13.113 18.2757 13.9262 17.1682C15.3946 15.1699 16.7698 13.1187 17.713 10.8302C18.2904 9.42956 18.6033 8.00136 18.3572 6.47568ZM10.5287 10.701C8.74881 10.696 7.30168 9.29607 7.31049 7.58957C7.32004 5.88377 8.7804 4.49724 10.561 4.5043C12.3196 4.51137 13.766 5.91202 13.7653 7.60722C13.7646 9.31514 12.3086 10.7059 10.5287 10.701Z",
    fill: "#7D01F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon1);
export default __webpack_public_path__ + "static/media/location-icon1.3bc2245e98b6a1ad43762fcb7c75e4fe.svg";
export { ForwardRef as ReactComponent };